<template>
  <div class>
    <div>
      <div class="show-state">
        <a-button-group>
          <a-button
            size="small"
            v-for="(item, index) in showTag"
            :type="item.state == 1 ? 'primary' : ''"
            :key="index"
            style="margin-right:0"
            >{{ item.label }}</a-button
          >
        </a-button-group>
      </div>
      <div style="padding:0 10px">
        <a-select
          style="width:220px"
          v-model="param.siteid_article"
          @change="handleChange"
        >
          <a-select-option v-for="item in siteLists" :key="item.siteid">
            {{ item.sitename }}
          </a-select-option>
        </a-select>
      </div>
      <div style="padding:0 10px">
        <a-input-search
          style="margin:8px 0"
          placeholder="输入标题的一部分或全部搜索"
          v-model="searchValue"
          enter-button="查询"
          @search="onSearch"
        ></a-input-search>
      </div>
      <div style="padding:0 10px">
        <a-table
          :columns="columns"
          :dataSource="lists"
          :pagination="pagination"
          :rowKey="record => record.id"
          :loading="loding"
          size="small"
          @change="handleTableChange"
        >
          <template slot="centerUsed" slot-scope="text, record, index">
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="check(text)"
              size="small"
              @change="
                checked => {
                  changeCheck(checked, record.id, index);
                }
              "
            />
          </template>
          <template slot="tableTitle" slot-scope="text, record">
            <span class="table-title" @click="getPreview(record.id)">{{
              intercept(text)
            }}</span>
          </template>
          <template slot="cover" slot-scope="text, record">
            <span v-if="record.headpic.length > 0">有</span>
            <span v-else>无</span>
          </template>
          <template slot="type" slot-scope="text, record">
            <span v-if="record.headpic.length > 0 && record.linkurl == ''"
              >图片</span
            >
            <span v-if="record.linkurl != ''">外链</span>
            <span v-if="(record.headpic.length = 0 && record.linkurl == '')"
              >普通</span
            >
          </template>
          <template slot="audit" slot-scope="text">
            <span v-if="text == 100" class="success">已发布</span>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: true,
    key: 'id'
  },
  {
    title: '是否选用',
    dataIndex: 'centerUsed',
    align: 'center',
    scopedSlots: { customRender: 'centerUsed' }
  },
  {
    title: '文章标题',
    dataIndex: 'title',
    key: 'title',
    scopedSlots: { customRender: 'tableTitle' },
    width: '300px'
  },
  {
    title: '是否有封面',
    scopedSlots: { customRender: 'cover' },
    align: 'center'
  },
  {
    title: '文章类型',
    scopedSlots: { customRender: 'type' },
    key: 'type',
    align: 'center'
  },
  {
    title: '发布时间',
    key: 'pubtime',
    sorter: true,
    dataIndex: 'pubtime'
  },
  {
    title: '发布人',
    key: 'truename',
    dataIndex: 'truename'
  },
  {
    title: '审核状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'audit' }
  }
];
export default {
  data() {
    return {
      columns,
      lists: [],
      loding: false,
      pagination: {
        pageSize: 20
      },
      siteLists: [
        {
          siteid: '2',
          deptid: '1',
          sitename: '三峡宜昌网',
          keywords: '',
          description: '',
          domain: 'http://www.cn3x.com.cn/',
          setting: '{"template": "cn3x"}'
        },
        {
          siteid: '16',
          deptid: '2',
          sitename: '西陵融媒体',
          keywords: '',
          description: '',
          domain: 'http://www.sxxlw.cn/',
          setting: '{"template": "xiling"}'
        },
        {
          siteid: '3',
          deptid: '3',
          sitename: '三峡夷陵网',
          keywords: '',
          description: '',
          domain: 'http://test.5210.cn/',
          setting: '{"template": "yiling"}'
        },
        {
          siteid: '18',
          deptid: '4',
          sitename: '伍家融媒体',
          keywords: '',
          description: '',
          domain: 'http://wujia.ycrmt.cn/',
          setting: '{"template": "wujia"}'
        },
        {
          siteid: '15',
          deptid: '5',
          sitename: '点军融媒体',
          keywords: '',
          description: '',
          domain: 'http://dianjun.ycrmt.cn/',
          setting: '{"template": "dianjun"}'
        },
        {
          siteid: '19',
          deptid: '6',
          sitename: '猇亭融媒体',
          keywords: '',
          description: 'http://xiaoting.ycrmt.cn/',
          domain: 'http://www.ycxtnews.com/',
          setting: '{"template": "xiaoting"}'
        },
        {
          siteid: '20',
          deptid: '7',
          sitename: '高新融媒体',
          keywords: '',
          description: '',
          domain: '',
          setting: '{"template": "gaoxin"}'
        },
        {
          siteid: '21',
          deptid: '8',
          sitename: '宜都融媒体',
          keywords: '',
          description: 'http://www.hbyidu.com/',
          domain: 'http://www.hbyidu.com/',
          setting: '{"template": "yidu"}'
        },
        {
          siteid: '10',
          deptid: '9',
          sitename: '三峡枝江网',
          keywords: '',
          description: 'http://zhijiang.ycrmt.cn/',
          domain: 'http://www.sxzhijiang.com/',
          setting: '{"template": "zhijiang"}'
        },
        {
          siteid: '6',
          deptid: '10',
          sitename: '当阳新闻网',
          keywords: '',
          description: 'http://www.hbdangyang.com/',
          domain: 'http://www.hbdangyang.com/',
          setting: '{"template": "dangyang"}'
        },
        {
          siteid: '11',
          deptid: '11',
          sitename: '远安云上APP',
          keywords: '',
          description: '',
          domain: '',
          setting: null
        },
        {
          siteid: '12',
          deptid: '12',
          sitename: '三峡秭归网',
          keywords: '',
          description: '',
          domain: 'http://www.sxzg.cn/',
          setting: '{"template": "zigui"}'
        },
        {
          siteid: '13',
          deptid: '13',
          sitename: '长阳云上APP',
          keywords: '',
          description: '',
          domain: '',
          setting: null
        },
        {
          siteid: '9',
          deptid: '14',
          sitename: '五峰新闻网',
          keywords: '',
          description: '',
          domain: 'http://www.hbwfnews.com/',
          setting: '{"template": "wufeng"}'
        },
        {
          siteid: '14',
          deptid: '15',
          sitename: '兴山云上APP',
          keywords: '',
          description: '',
          domain: '',
          setting: null
        },
        {
          siteid: '22',
          deptid: '16',
          sitename: '融媒体大屏',
          keywords: '',
          description: '',
          domain: '',
          setting: null
        }
      ],

      searchValue: '',
      showTag: [{ type: 2, label: '已审', state: 1 }],
      param: {
        page: 1,
        limit: 20,
        title: '',
        catid: '',
        order: 'id',
        ordertype: 'desc',
        siteid_article: '2'
      }
    };
  },
  methods: {
    getLists() {
      this.loding = true;
      this.param.show = '0100'; //已发布的文章
      this.param.center = 1; //无视区域id获取全部文章
      this.$http.post('/api/content/cloudlist', this.param).then(res => {
        if (res.data.state == 200) {
          const pagination = { ...this.pagination };
          for (let i in res.data.data) {
            let pic = [];
            if (
              res.data.data[i].headpic === null ||
              res.data.data[i].headpic == '[]'
            ) {
              pic = new Array();
            } else {
              if (res.data.data[i].headpic.indexOf(',') > 0) {
                pic = JSON.parse(res.data.data[i].headpic);
              } else {
                pic.push(res.data.data[i].headpic);
              }
            }
            res.data.data[i].headpic = pic;
          }
          pagination.total = res.data.pages * 20;
          this.lists = res.data.data;
          this.pagination = pagination;
        } else {
          this.lists = [];
        }
        this.loding = false;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      this.param.page = this.pagination.current;
      this.param.order = sorter.field;
      this.param.ordertype = sorter.order == 'ascend' ? 'asc' : 'desc';
      this.getLists();
    },
    handleChange(value) {
      this.param.siteid_article = value;
      this.getLists();
    },
    onSearch(value) {
      this.searchValue = value;
      this.param.page = 1;
      this.param.title = value;
      this.param.catid = this.catid;
      this.getLists();
    },
    getPreview(id) {
      this.$emit('getdetails', id);
    },
    intercept(text) {
      let html = text;
      if (text.length > 30) {
        html = html.substr(0, 30) + '...';
      }
      return html;
    },
    getaddList(id, type, index) {
      this.$http
        .post('api/content/centerUse', {
          id,
          type
        })
        .then(res => {
          if (res.data.state === 200) {
            this.lists[index].centerUsed = type;
          }
        });
    },
    check(type) {
      if (type == '1') {
        return true;
      } else if (type == '0') {
        return false;
      }
    },
    changeCheck(checked, id, index) {
      let type = 0;
      if (checked) {
        type = 1;
      } else {
        type = 0;
      }
      this.getaddList(id, type, index);
    }
  },
  created() {
    this.getLists();
    // this.siteLists = JSON.parse(localStorage.getItem('siteLists'));
  }
};
</script>
<style scoped>
.show-state {
  border-bottom: 1px solid #e8e8e8;
  padding: 0 12px 8px 10px;
  margin: 15px 0px 8px 0;
  text-align: left;
}
.table-title {
  color: #041aed;
  cursor: pointer;
}
.cursor {
  cursor: pointer;
}
</style>
